<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Misc and Other Fees Payment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-combobox color="#0f2027" rounded v-model="selected_children" :items="children" label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle" @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="button" @click="getDetails()">Proceed</v-btn>
                </v-col>
            </v-row>
            <span v-if="show == true">
                <v-row justify="center">
                    AY ::{{current_ay}} || Standard :: {{leaner_std}} || Division :: {{leaner_div}}
                </v-row>
                <v-data-table :headers="headers" :items="misc_fees_list" dense class="mytable elevation-1" :search="search">
                    <template v-slot:item.action="{ item }">
                        <span v-if="item.pay == false">
                        <strong>Already Paid</strong>
                        </span>
                        <span v-else>
                            <!-- <input type="hidden" :value="item.orgid" name="orgid" />
                                <input type="hidden" :value="item.tenantid" name="tenantid" />
                                <input type="hidden" :value="item.uid" name="uid" />
                                <input type="hidden" :value="item.learner_id" name="studid" />
                                <input type="hidden" :value="item.amount" name="fee_amount"/>
                                <input type="hidden" :value="item.miscfeesmaster" name="purpose"/>
                                <input type="hidden" :value="item.id" name="json_pre_trans_data"/>
                                <input type="hidden" :value="item.hash_val" name="hash_val"/> -->
                            <v-btn small class="button" @click="proceed(item.learner_id,item.id,item.miscfeesmaster,item.amount)"  :loading="loader">Proceed</v-btn> 
                        </span>        
                    </template>
                </v-data-table>
            </span>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            child_info: null,
            children: [],
            selected_install: [],
            get_component_installmet_list: [],
            show: false,
            selected_children: "",
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            s3url: "",
            misc_fees_list:"",
            leaner_div:null,
            leaner_std:null,
            url:"",
            headers: [
                {text: "Sr. No.", value: "srno", sortable: false},
                { text: "Misc", value: "miscfeesmaster", sortable: false },
                { text: "Amount", value: "amount", sortable: false },
                { text: "Action", value: "action", sortable: false },
            ],
            returnURL: "",
            checksumurl: "",
        }),
         created(){
        // this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm"
         //this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_misc"
         // axios.defaults.baseURL = "http://localhost:8080"
    },
        methods: {
             payFees() {
                 //alert("alert in payfee")
                 //alert(this.returnURL)
                    bdPayment.initialize({
                        msg: this.checksumurl,
                        callbackUrl: this.returnURL,
                        options: {
                            enableChildWindowPosting: true,
                            enablePaymentRetry: true,
                            retry_attempt_count: 2,
                        },
                    });
                },
            //payment(id,amount,learner_div_id){
                payment(){
               var formData = new FormData(paytmform);
               console.log("formData")
               console.log(formData)
               this.loader= false
            },
            //proceed(item.learner_id,item.id,item.miscfeesmaster,item.amount)
            proceed(learner_id,id,miscfeesmaster,amount){
                const data = {
                    learner_id : learner_id,
                    misc_fees_id : id,
                    purpose : miscfeesmaster,
                    fee_amount : amount,
                    json_pre_trans_data : id,
                }
                axios
                .post("/AccountingAndFees/getMiscPaymentInfoBillDesk", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.checksumurl = res.data.checksumurl;
                            this.returnURL = res.data.returnURL;
                            this.payFees()
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            getDetails() {
                const formData = {
                    child: this.selected_children.id,
                };
                axios
                   // .post("/AccountingAndFees/getMiscPaymentInfoBillDesk", formData)
                    .post("/AccountingAndFees/getMiscPaymentInfo", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.show = true;
                            this.current_ay = res.data.current_ay;
                            this.leaner_std = res.data.leaner_std;
                            this.leaner_div = res.data.leaner_div;
                            this.misc_fees_list = res.data.misc_fees_list
                           // this.returnURL = res.data.returnURL;
                           // this.hashval = sha256(learner_id+amt+process.env.VUE_APP_SHA_KEY)
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                    //alert("done")
                });
        },
    };
</script>

<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
